export default {
  title: 'Parece que está offline',
  description:
    'Por favor clique em «Recarregar Página» e/ou verifique a sua ligação à internet para garantir que está online 😊',
  custom_button: {
    reload: 'Recarregar Página',
  },
};
